














import { mapGetters } from 'vuex'
import { VEHICLE_TYPE } from '@/shared/constants'

export default {
  props: {
    order: { type: Object, required: true },
    lineLength: { type: Number, default: 26 }
  },
  computed: {
    ...mapGetters(['vehicleTypes']),
    allowedVehicles() {
      const { allowedVehicleTypes, vehicleTypeName } = this.order
      const allowedVehicles = allowedVehicleTypes || []
      return allowedVehicles.length ? allowedVehicles : [vehicleTypeName]
    },
    hasMultipleVehicles() {
      return this.allowedVehicles.length > 1
    },
    formattedVehicleTypes() {
      return this.allowedVehicles
        .map(this.getHumanReadableVehicleName)
        .sort()
        .join(', ')
    },
    shouldBeTruncated() {
      //truncate vehicles list when is longer than 2 lines
      return this.formattedVehicleTypes.length > this.lineLength * 2
    },
    tooltipContent() {
      //show tooltip when vehicle list is longer than 2 lines
      return this.shouldBeTruncated ? this.formattedVehicleTypes : null
    }
  },
  methods: {
    getHumanReadableVehicleName(vehicleType) {
      const vehicleName = this.vehicleTypes[vehicleType]
      if (
        vehicleType === VEHICLE_TYPE.FRIGO_TRUCK &&
        this.order.isTemperatureControlled
      ) {
        return this.appendTemperatureSpecifications(vehicleName)
      }
      return vehicleName
    },
    appendTemperatureSpecifications(vehicleName) {
      const minTemperature = this.order.loadMinimumTemperature.toFixed(1)
      const maxTemperature = this.order.loadMaximumTemperature.toFixed(1)
      const separator = this.$t(
        'orderDetails.vehicleSpecifications.temperatureRangePreposition'
      )
      const temperatureSpecifications = `${minTemperature} ${separator} ${maxTemperature}`
      return `${vehicleName} (${temperatureSpecifications} °C)`
    }
  }
}
